// Angular
import { Component, OnInit, EventEmitter, Output } from '@angular/core';
// 3rd-party
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
// services
import { ConfigService } from 'src/app/services/config.service';

@Component({
    selector: 'app-captcha-modal',
    templateUrl: './captcha-model.component.html',
    styleUrls: ['./captcha-model.component.scss'],
    standalone: false
})
export class CaptchaModelComponent implements OnInit {
    helper: any = {};

    @Output() resolved = new EventEmitter();

    constructor(private ConfigService: ConfigService, private ActiveModal: NgbActiveModal) {}

    ngOnInit(): void {}

    resolveCaptcha() {
        this.helper.resolved = true;
        this.ConfigService.setConfig({ token2: this.helper.token });
        this.resolved.emit();
        setTimeout(() => {
            this.ActiveModal.dismiss();
        }, 400);
    }

    canExit() {
        return this.helper.resolved;
    }
}
